module.exports = __webpack_public_path__ + "assets/img/icon6.ca05cbad.svg";